import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './SchoolsList.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListStudents extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToView = this.goToView.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToView(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'institutions/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }


    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToView(props)}>View More</button>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;


        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const schoolsDataKey = ["id", "Name", "Created", "view"];
        
        const schoolsThead = ["ID", "Name", "Created", "Action"];

        const schoolsRes = await adminAPI.getSchools();

        if (schoolsRes.ok) {
            
            const schools = schoolsRes.data.schools;

            this.setState(
                {
                     data: {
                        schools,
                        loaded: true,
                        schoolsDataKey,
                        schoolsThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <SortableTbl
                    tblData={data.schools}
                    tHead={data.schoolsThead}
                    dKey={data.schoolsDataKey}
                    customTd={[
                        { custd: this.customTD, keyItem: "view", sortable: false }
                    ]}
                    defaultCSS={false}
                />

              </Content>

              
              </Wrapper>
        );

    }

}

export default withServices(ListStudents);


// WEBPACK FOOTER //
// ./src/pages/Admin/Schools/SchoolsList/SchoolsList.tsx